<template>
  <div>
    <v-text-field
      v-model="formData.tanggal"
      type="date"
      label="Tanggal"
      outlined
      clearable
      dense
      autofocus
      @keydown.enter="fetchLaporan"
    ></v-text-field>
    <v-checkbox
      v-model="formData.hanya_selesai"
      label="Hanya tampilkan data yang masuk pelaporan pajak"
      hide-details
      dense
      class="mb-2"
    ></v-checkbox>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <div class="d-flex">
          <h1 class="report-title-light mr-5">
            {{ portAwal.text }} - LAPORAN HARIAN CASHIER
          </h1>
          <div class="border">
            <h2 class="report-title-light">
              {{ formatDate(formData.tanggal) }}
            </h2>
          </div>
        </div>
      </div>

      <div class="body">
        <div class="d-flex">
          <div class="w-40">
            <!-- <div class="w-100 d-flex justify-content-between">
              <h3 class="font-italic font-weight-light">Pendapatan</h3>
              <h3 class="font-weight-light">
                Rp. {{ formatCurrency(totalPendapatan) }}
              </h3>
            </div>
            <div class="w-100 d-flex justify-content-between">
              <h3 class="font-italic font-weight-light">Giro</h3>
              <h3 class="font-weight-light">
                Rp. 0
              </h3>
            </div> -->
            <div class="w-100 d-flex justify-content-between">
              <h3 class="font-italic font-weight-light">Upah Buruh</h3>
              <h3 class="font-weight-light">
                Rp. {{ formatCurrency(totalPengeluaranBuruh) }}
              </h3>
            </div>
            <div class="w-100 d-flex justify-content-between">
              <h3 class="font-italic font-weight-light">Biaya Truck</h3>
              <h3 class="font-weight-light">
                Rp. {{ formatCurrency(totalPengeluaranTruk) }}
              </h3>
            </div>
            <div class="w-100 d-flex justify-content-between">
              <h3 class="font-italic font-weight-light">Biaya Lain</h3>
              <h3 class="font-weight-light">
                Rp. {{ formatCurrency(totalLainLain) }}
              </h3>
            </div>
            <!-- <div class="w-100 d-flex justify-content-between">
              <h3 class="font-italic font-weight-light"></h3>
              <h3 class="font-weight-light border">
                Rp.
                {{
                  formatCurrency(
                    -totalPengeluaranTruk +
                      -totalPengeluaranBuruh +
                      -totalLainLain
                  )
                }}
              </h3>
            </div> -->
          </div>
          <div>
            <!-- <h2 class="mt-5 ml-5">
              {{ formatCurrency(sisa_cash) }}
            </h2> -->
          </div>
        </div>
        <!-- <div class="mt-5">
          <h2 class="report-title">Pendapatan Lain-lain</h2>

          <div v-for="(value, name, index) in data.pendapatan" :key="name">
            <p><b>Kategori:</b> {{ name }}</p>

            <table class="w-100">
              <thead>
                <tr>
                  <th width="15%">Oleh</th>
                  <th width="10%">Jenis</th>
                  <th width="35%">Untuk Keperluan</th>
                  <th width="20%">Rp</th>
                  <th width="5%">KV</th>
                  <th width="5%">KC</th>
                  <th width="15%">ACC</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in value" :key="index">
                  <td class="text-center">{{ item.oleh.nama }}</td>
                  <td class="text-center">{{ item.jenis }}</td>
                  <td class="text-center">{{ item.keperluan }}</td>
                  <td class="text-center">
                    Rp.
                    {{ formatCurrency(item.nominal) }}
                  </td>
                  <td class="text-center">{{ item.kv }}</td>
                  <td class="text-center">{{ item.kc }}</td>
                  <td class="text-center">{{ item.acc.nama }}</td>
                </tr>
                <tr>
                  <td colspan="3" class="text-right">Total:</td>
                  <td class="text-center">
                    Rp.
                    {{
                      formatCurrency(
                        value.reduce((acc, cur) => acc + cur.nominal, 0)
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->
        <div class="mt-5">
          <h2 class="report-title">Pengeluaran Upah Buruh</h2>

          <div v-for="(value, name) in data.buruh" :key="name">
            <p><b>KV:</b> {{ name }}</p>

            <table class="w-100">
              <thead>
                <tr>
                  <th width="10%">NoNota</th>
                  <th width="50%">Keterangan</th>
                  <th width="10%">Jumlah</th>
                  <th width="10%">Harga</th>
                  <th width="30%" class="text-right">UpahBuruh</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in value">
                  <tr
                    v-for="itemDetail in item.invoice_detil"
                    :key="itemDetail.id"
                  >
                    <td class="text-center">{{ itemDetail.nomor_nota }}</td>
                    <td class="text-center">{{ itemDetail.keterangan }}</td>
                    <td class="text-center">
                      {{ itemDetail.jumlah }}
                    </td>
                    <td class="text-center">
                      {{ formatCurrency(itemDetail.harga_satuan) }}
                    </td>
                    <td class="text-right">
                      Rp.
                      {{ formatCurrency(itemDetail.kalkulasi_upah) }}
                    </td>
                  </tr>
                </template>
                <tr>
                  <td colspan="4" class="text-right">Total Dibayar:</td>
                  <td class="text-right">
                    Rp. {{ formatCurrency(totalPengeluaranBuruh) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-5">
          <h2 class="report-title">Pengeluaran Untuk Truck</h2>

          <div v-for="(value, name, index) in data.truk" :key="name">
            <p><b>KV:</b> {{ name }}</p>

            <table class="w-100">
              <thead>
                <tr>
                  <th width="10%">NoNota</th>
                  <th width="15%">NoPol</th>
                  <th width="15%">No TTB</th>
                  <th width="25%">Keterangan</th>
                  <th width="5%">Koli</th>
                  <th width="5%">M3</th>
                  <th width="25%" class="text-right">BiayaTruk</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in value">
                  <tr
                    v-for="itemDetail in item.invoice_detil"
                    :key="itemDetail.id"
                  >
                    <td class="text-center">{{ item.nomor_nota }}</td>
                    <td class="text-center">{{ item.nomor_polisi }}</td>
                    <td class="text-center">{{ itemDetail.nottb }}</td>
                    <td class="text-center">{{ itemDetail.keterangan }}</td>
                    <td class="text-center">
                      {{
                        itemDetail.ttb_rinci.reduce(
                          (a, b) => a + parseFloat(b.koli),
                          0
                        )
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        itemDetail.ttb_rinci.reduce(
                          (a, b) => a + parseFloat(b.m3),
                          0
                        )
                      }}
                    </td>
                    <td class="text-right">
                      Rp.
                      {{
                        kalkulasiBiayaTruk(
                          item.total,
                          itemDetail.ttb_rinci.reduce(
                            (a, b) => a + parseFloat(b.m3),
                            0
                          ),
                          item.invoice_detil.reduce(
                            (a, b) =>
                              a +
                              b.ttb_rinci.reduce(
                                (c, d) => c + parseFloat(d.m3),
                                0
                              ),
                            0
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <!-- <tr>
                    <td colspan="6"></td>
                    <td class="text-right">
                      Rp.
                      {{ formatCurrency(Math.abs(item.total)) }}
                    </td>
                  </tr> -->
                  <tr>
                    <td colspan="7">
                      <hr />
                    </td>
                  </tr>
                </template>
                <!-- <tr v-for="(item, index) in value" :key="index">
                  <td class="text-center">{{ item.nomor_nota }}</td>
                  <td class="text-center">{{ item.nomor_polisi }}</td>
                  <td class="text-left">{{ item.keterangan_barang }}</td>
                  <td class="text-center">
                    {{ countTotalKoli(item.invoice_detil) }}
                  </td>
                  <td class="text-center">
                    {{ countTotalM3(item.invoice_detil) }}
                  </td>
                  <td class="text-right">
                    Rp.
                    {{ formatCurrency(-Math.abs(item.total)) }}
                  </td>
                </tr> -->
                <tr>
                  <td colspan="6" class="text-right">Total Dibayar:</td>
                  <td class="text-right">
                    Rp. {{ formatCurrency(totalPengeluaranTruk) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-5">
          <h2 class="report-title">Pengeluaran Lain-lain</h2>

          <div v-for="(value, name, index) in data.lain" :key="name">
            <p><b>Kategori:</b> {{ name }}</p>

            <table class="w-100">
              <thead>
                <tr>
                  <th width="10%">Nomor</th>
                  <th width="15%">Oleh</th>
                  <th width="10%">Jenis</th>
                  <th width="35%">Untuk Keperluan</th>
                  <th width="20%">Rp</th>
                  <th width="5%">KV</th>
                  <th width="5%">KC</th>
                  <th width="15%">ACC</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in value" :key="index">
                  <td class="text-center">{{ item.id }}</td>
                  <td class="text-center">{{ item.oleh.nama }}</td>
                  <td class="text-center">{{ item.jenis }}</td>
                  <td class="text-center">{{ item.keperluan }}</td>
                  <td class="text-center">
                    Rp.
                    {{ formatCurrency(Math.abs(item.nominal)) }}
                  </td>
                  <td class="text-center">{{ item.kv }}</td>
                  <td class="text-center">{{ item.kc }}</td>
                  <td class="text-center">{{ item.acc.nama }}</td>
                </tr>
                <tr>
                  <td colspan="4" class="text-right">Total Dibayar:</td>
                  <td class="text-center">
                    Rp. {{ formatCurrency(totalLainLain) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      portAwal: JSON.parse(localStorage.getItem("port_awal")),
      state: {
        loading: false,
        noData: true
      },
      formData: {
        tanggal: new Date().toISOString().substr(0, 10),
        hanya_selesai: true
      },
      sisa_cash: 0,
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    totalPendapatan() {
      let total = 0;

      for (const item in this.data.pendapatan) {
        for (const detail of this.data.pendapatan[item]) {
          total += Math.abs(detail.nominal);
        }
      }

      return total;
    },
    totalPengeluaranBuruh() {
      let total = 0;

      for (const item in this.data.buruh) {
        for (const detail of this.data.buruh[item]) {
          total += Math.abs(detail.total);
        }
      }

      return total;
    },
    totalPengeluaranTruk() {
      let total = 0;

      for (const item in this.data.truk) {
        for (const detail of this.data.truk[item]) {
          total += Math.abs(detail.total);
        }
      }

      return total;
    },
    totalLainLain() {
      let total = 0;

      // for (const item in this.data.lain) {
      //   for (const detail of this.data.lain[item]) {
      //     if (detail.jenis === "keluar") {
      //       total += Math.abs(detail.nominal);
      //     } else if (detail.jenis === "masuk") {
      //       total -= Math.abs(detail.nominal);
      //     }
      //   }
      // }

      for (const item in this.data.lain) {
        for (const detail of this.data.lain[item]) {
          total += Math.abs(detail.nominal);
        }
      }

      return total;
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchLaporan() {
      this.state.loading = true;

      await axios
        .get(
          `kas/laporan-pengeluaran-keseluruhan?tanggal=${
            this.formData.tanggal
          }&hanya_selesai=${this.formData.hanya_selesai ? 1 : 0}`
        )
        .then(res => {
          if (!res.data) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data.data;
            this.sisa_cash = res.data.sisa_cash;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    countTotalKoli(data) {
      let total = 0;

      data.forEach(ttb => {
        ttb.ttb_rinci.forEach(rinci => {
          total += parseFloat(rinci.koli);
        });
      });

      return total;
    },
    countTotalM3(data) {
      let total = 0;

      data.forEach(ttb => {
        ttb.ttb_rinci.forEach(rinci => {
          total += parseFloat(rinci.m3);
        });
      });

      return total.toFixed(2);
    },
    kalkulasiBiayaTruk(total, m3, totalM3) {
      return this.formatCurrency(((total / totalM3) * m3).toFixed(2));
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      if (num < 0) {
        return `(${new Intl.NumberFormat("id-ID").format(Math.abs(num))})`;
      } else {
        return new Intl.NumberFormat("id-ID").format(num);
      }
    }
  },
  mounted() {
    // console.log(localStorage.getItem("port_awal"));
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report-title-light {
  font-weight: 400;
  text-decoration: underline;
}

.border {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: 1px solid black;
  line-height: 1;
  padding: 0 5px;
}

.border h2 {
  text-decoration: none;
}

.w-30 {
  width: 30%;
}

.w-40 {
  width: 40%;
}

.justify-content-between {
  justify-content: space-between;
}

th {
  font-weight: bold !important;
}
</style>
